import { UseMutationOptions } from 'react-query'
import { metadataDisplayToAgentLabel } from '../common/utils'
import { ThisConnector } from '../../../../../api/connector'
import { HTTPError } from '../../../../../api/fetch/decorate-fetch'
import { useContrastMutation } from '../../../../../hooks/use-contrast-mutation'

interface Response {
  application: {
    app_id: string
  }
  readonly success: boolean
  readonly messages: string[]
}

type AppRegisterArgs = {
  organizationUuid: string
  language: string
  name?: string
  appGroups?: string[]
  appTags?: string[]
}

export async function postAppRegister(
  this: ThisConnector,
  args: AppRegisterArgs
) {
  const {
    organizationUuid,
    language,
    name,
    appGroups,
    appTags,
    ...metadataFields
  } = args

  // parse(stringify) to remove undefined keys
  return this.connector.post(
    `/organizations/${organizationUuid}/wizard/applications`,
    JSON.parse(
      JSON.stringify({
        language,
        name,
        appGroups: appGroups?.join(',') || undefined,
        tags: appTags?.join(',') || undefined,
        metadata:
          Object.keys(metadataFields)
            ?.filter((key) => metadataFields[key])
            ?.map(
              (key) =>
                `${metadataDisplayToAgentLabel(key)}=${metadataFields[key]}`
            )
            .join(',') || undefined
      })
    )
  )
}

export function useMutateAppRegister(
  options?: UseMutationOptions<Response, Error, AppRegisterArgs>
) {
  return useContrastMutation<Response, HTTPError, AppRegisterArgs>(
    postAppRegister,
    options
  )
}
